import json from './sprite.js';

export default {
    handle: 'SP_SPT8-Doctor',
    label: 'es_SPT8-Doctor_234684216',
    json,
};
